import { Component, input } from "@angular/core";

@Component({
  selector: "app-static-why-love",
  imports: [],
  templateUrl: "./static-why-love.component.html",
  styleUrl: "./static-why-love.component.css",
})
export class StaticWhyLoveComponent {
  subject = input<any>();
}
